var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gis-page"},[(_vm.$i18n.locale==='en-US')?_c('google-map'):_c('gaode-map')],1)}
var staticRenderFns = []

export { render, staticRenderFns }